import { Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconFunction, Tag } from 'ui'
import { CardItem } from './CardItem'
import { CardLine } from './CardLine'
import { messages } from './messages'

const FUNCTIONS = [
  {
    description: messages.function.min,
    function: 'min(a, b)',
  },
  {
    description: messages.function.max,
    function: 'max(a, b)',
  },
  {
    description: messages.function.floor,
    function: 'floor(a)',
  },
]

export function FunctionsCard() {
  const { $t } = useIntl()

  return (
    <CardItem
      name="functions"
      icon={<IconFunction />}
      title={$t(messages.function.title)}
      link={$t(messages.function.link)}
    >
      {FUNCTIONS.map(({ description, function: formulaFunction }, index) => (
        <CardLine columns="split" key={index}>
          <div>
            <Tag>{formulaFunction}</Tag>
          </div>
          <Text>
            <FormattedMessage
              values={{
                b: (content) => <Text variant="action1">{content}</Text>,
              }}
              {...description}
            />
          </Text>
        </CardLine>
      ))}
    </CardItem>
  )
}
